<template>
    <v-app id="reset-this-root" :class="{'small-window' : !this.$store.getters.getToken, 'mobile': $vuetify.breakpoint.mobile}" class="sticky-web-chat">
      <v-main>
        <web-chat-button v-show="fetchedTheming" :mainColor="mainColor" :clientImage="clientImage" :poweredBy="poweredBy" :title="title" :welcomeMessage="welcomeMessage" :welcomeTitle="welcomeTitle" :buttontitle="buttontitle" :bubbleMessage="bubbleMessage"/>
      </v-main>
    </v-app>
</template>

<script>
import WebChatButton from '@/components/WebChatButton'
import userService from '@/services/user.js'

export default {
  components: {
    WebChatButton
  },
  data: () => ({
    mainColor: null,
    clientImage: null,
    poweredBy: null,
    fetchedTheming: false,
    title: '',
    welcomeMessage: '',
    welcomeTitle: '',
    buttontitle: '',
    bubbleMessage: ''
  }),
  created() {
    this.getTheming()
  },
  methods: {
    getTheming() {
        userService.getTheming().then(resp => {
            this.mainColor = resp.data.mainColor
            this.clientImage = resp.data.clientLogo
            this.poweredBy = resp.data.showPoweredByLabel
            this.fetchedTheming = true
            this.title = resp.data.title
            this.welcomeMessage = resp.data.getStartedConfig.subject
            this.welcomeTitle = resp.data.getStartedConfig.title
            this.buttontitle = resp.data.getStartedConfig.button_title
            this.bubbleMessage = resp.data.getStartedConfig.bubbleMessage
            this.$store.dispatch('setClientImage', resp.data.clientLogo)
        })
    },
  }
};
</script>

<style scoped>
  .sticky-web-chat{
    position: fixed;
    bottom: -56px;
    right: 10px;
    z-index: 2147483647;
    background-color: transparent !important;
  }
  .sticky-web-chat.small-window {
    bottom: unset;
    top: 30vh;
  }

  .sticky-web-chat.mobile {
    right: 0px!important;
    top: 0px!important;
  }

  /* @media only screen and (max-height: 375px) {
    .sticky-web-chat.small-window {
      bottom: unset;
      top: 25vh;
    }
  } */
  @media only screen and (max-height: 735px) {
    .sticky-web-chat.small-window {
      bottom: unset;
      top: 17vh;
    }
  }

  @media only screen and (max-height: 700px) {
    .sticky-web-chat.small-window {
      bottom: unset;
      top: 13vh;
    }

    .sticky-web-chat {
      bottom: unset;
      top: 2vh;
    }
  }

  @media only screen and (max-height: 910px) {
    .sticky-web-chat {
      bottom: unset;
      top: 2vh;
    }
  }

  @media only screen and (max-height: 562px) {
    .sticky-web-chat {
      bottom: unset;
      top: 3vh;
    }
    .sticky-web-chat.small-window {
      bottom: unset;
      top: 20vh;
    }
  }

</style>

<style>
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #9b9a9a;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: v-bind(mainColor);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: white;
}

.v-list-item__title:hover {
    cursor: pointer;
    color: v-bind(mainColor) !important;
    background: white;
}

.v-window__prev, .v-window__next {
  background: #00000000 !important;
  background-color: v-bind(mainColor) !important;
}

.theme--light.v-icon {
    color: v-bind(mainColor) !important;
}

.close-btn-control .v-icon, .closes-btn-control i {
    color: #fff !important;
}
/* Relative Font Sizes & Line Heights  (replacing rem units) */
main.v-main {
  --font-size: 16px;
}

main.v-main .container .chat-bubble-welcome {
  font-size: calc(.9 * var(--font-size)) !important;
}

main.v-main .container .text-h5 {
  font-size: calc(1.5 * var(--font-size)) !important;
  line-height: calc(1.333 * var(--font-size)) !important;
}

main.v-main .container .text-h6 {
  font-size: calc(1.25 * var(--font-size)) !important;
  line-height: calc(1.6 * var(--font-size)) !important;
}

main.v-main .container .text-subtitle-1,
main.v-main .container .v-textarea textarea {
  font-size: var(--font-size) !important;
  font-weight: 400 !important;
  line-height: calc(1.75 * var(--font-size)) !important;
}

main.v-main .container .text-subtitle-2,
main.v-main .container .v-card__text {
  font-size: calc(.875 * var(--font-size)) !important;
}
main.v-main .container .text-subtitle-2 {
  line-height: calc(1.6 * var(--font-size)) !important;
}
main.v-main .container .v-card__text {
  line-height: calc(1.375 * var(--font-size)) !important;
}

main.v-main .container .text-caption,
main.v-main .container .v-size--small {
  font-size: calc(.75 * var(--font-size)) !important;
}
main.v-main .container .text-caption {
  line-height: calc(1.667 * var(--font-size)) !important;
}

.container--fluid {
  padding: 0px!important;
}
</style>

<style src="../node_modules/vuetify/dist/vuetify.min.css">
</style>

<style src="@mdi/font/css/materialdesignicons.css">
</style>